import get from 'lodash.get';

export const selectAggridFilter = (state) => get(state, 'aggridFilter');

export const selectAggridViewType = (state) => get(state, 'aggridFilter.viewType');

export const selectCurrentSelection = (state) => get(state, 'aggridFilter.selection');
